export default {
  // Navigation
  'nav.home': 'Home',
  'nav.solutions': 'Solutions',
  'nav.howWeWork': 'How We Work',
  'nav.about': 'About',

  // Shared CTA
  'cta.shapeYourProject': 'Shape Your Project',
  'cta.letsMeet': 'Let\'s Meet',

  // Footer
  'footer.rights': 'All rights reserved.',

  // Home — Hero
  'home.hero.badge': 'Enterprise Intelligence',
  'home.hero.slogan': 'One intelligent core. Multiple forms.',
  'home.hero.title1': 'Intelligence',
  'home.hero.titleShaped': 'shaped',
  'home.hero.title2': 'around your business',
  'home.hero.copy':
    'MorphenIQ designs custom AI, software and data solutions around your workflows, private information, systems and business goals.',
  'home.hero.support':
    'Your organization has its own way of working. Your technology should understand it.',
  'home.hero.explore': 'Explore What We Build',
  'home.hero.tag.customAi': 'Custom AI',
  'home.hero.tag.privateData': 'Private Data',
  'home.hero.tag.software': 'Software',
  'home.hero.tag.integrations': 'Integrations',
  'home.hero.tag.analytics': 'Analytics',
  'home.hero.tag.automation': 'Automation',
  'home.hero.caption': 'Connect what you already have. Build what you are missing.',
  'home.hero.flow': 'Systems → Intelligence → Results',
  'home.hero.scroll': 'Scroll',

  // Home — Intro video
  'home.intro.badge': 'Introducing MorphenIQ',
  'home.intro.title': 'See what we are all about',
  'home.intro.subtitle':
    'A quick look at how we shape intelligence around the way your business actually works.',

  // Home — Generic vs Custom
  'home.generic.badge': 'AI Differentiation',
  'home.generic.title1': 'Generic AI knows the world.',
  'home.generic.title2': 'Custom AI knows your organization.',
  'home.generic.paragraph':
    'General-purpose AI understands language and generates content. Business value becomes stronger when intelligence understands your terminology, processes, systems, permissions, data, users, and business context.',
  'home.generic.badgeNeural': 'Neural Architecture',
  'home.generic.badgeTrained': 'Trained on Your Data',
  'home.generic.statement1': 'Personalization is not a feature.',
  'home.generic.statement2': 'It is how we build.',
  'home.generic.diff.private.label': 'Private Data',
  'home.generic.diff.private.desc': 'Your information stays yours',
  'home.generic.diff.workflows.label': 'Your Workflows',
  'home.generic.diff.workflows.desc': 'Built around your processes',
  'home.generic.diff.roi.label': 'Measurable ROI',
  'home.generic.diff.roi.desc': 'Clear business outcomes',

  // Home — Outro video
  'home.outro.badge': 'The Bigger Picture',
  'home.outro.title': 'Where intelligence becomes momentum',
  'home.outro.subtitle':
    'A final look at how everything we build comes together to move your business forward.',

  // Home — Final CTA
  'home.final.badge': 'Ready to go deeper?',
  'home.final.title': 'See how we turn challenges into solutions',
  'home.final.subtitle': 'Explore the challenges we solve and the method behind every build.',
  'home.final.explore': 'Explore Solutions',
  'home.final.howWeWork': 'How We Work',

  // Solutions — Video
  'solutions.video.badge': 'Solutions',
  'solutions.video.title': 'Intelligence shaped around your challenges',
  'solutions.video.subtitle':
    'A quick look at how we turn fragmented complexity into unified, adaptive solutions.',

  // Solutions — Challenges
  'solutions.challenges.badge': 'Business Challenges',
  'solutions.challenges.title1': 'Technology should solve complexity,',
  'solutions.challenges.title2': 'not create more of it.',
  'solutions.challenges.paragraph': 'We start with the problem — not with a predetermined product.',
  'solutions.challenges.p1.title': 'Your knowledge is fragmented.',
  'solutions.challenges.p1.desc':
    'Information scattered across documents, systems, emails, and the expertise of a few key people.',
  'solutions.challenges.p2.title': 'Your reports are still manual.',
  'solutions.challenges.p2.desc':
    'Teams spend hours collecting, formatting, and distributing data that should flow automatically.',
  'solutions.challenges.p3.title': 'Your systems do not communicate.',
  'solutions.challenges.p3.desc':
    'ERP, CRM, databases, and tools operate in isolation, creating duplicate work and data silos.',
  'solutions.challenges.p4.title': 'Your data exists, but is difficult to use.',
  'solutions.challenges.p4.desc':
    'Rich information is trapped in unstructured formats, incompatible formats, or inaccessible locations.',
  'solutions.challenges.p5.title': 'Standard software does not fit your process.',
  'solutions.challenges.p5.desc':
    'Generic solutions force compromises. Your team creates workarounds instead of working efficiently.',
  'solutions.challenges.p6.title': 'You want AI, but do not know where to start.',
  'solutions.challenges.p6.desc':
    'The potential is clear. The roadmap is not. You need a partner who understands both technology and your business.',
  'solutions.challenges.before.label': 'Fragmented',
  'solutions.challenges.before.value': 'Before',
  'solutions.challenges.after.label': 'Unified',
  'solutions.challenges.after.value': 'After',
  'solutions.challenges.cta': 'Recognize any of these challenges in your organization?',

  // How We Work — Video
  'howwe.work.video.badge': 'How We Work',
  'howwe.work.video.title': 'See how we shape your business',
  'howwe.work.video.subtitle':
    'A quick look at how the MorphenIQ method adapts technology to the way your business actually works.',

  // How We Work — Philosophy
  'howwe.work.philosophy.badge': 'Brand Philosophy',
  'howwe.work.philosophy.title1': 'Your business has its own logic.',
  'howwe.work.philosophy.title2': 'Your technology should too.',
  'howwe.work.traditional.label': 'Traditional Technology',
  'howwe.work.traditional.sub': 'Business adapts to Technology',
  'howwe.work.traditional.desc':
    'Most software asks you to fit your processes into predefined workflows, generic terminology, and standardized data structures.',
  'howwe.work.traditional.arrow': 'Rigid, one-size-fits-all approach',
  'howwe.work.morpheniq.label': 'MorphenIQ',
  'howwe.work.morpheniq.sub': 'Technology adapts to Business',
  'howwe.work.morpheniq.desc':
    'We first understand how your organization works, then shape the intelligence, software, and data architecture around it.',
  'howwe.work.morpheniq.arrow': 'Adaptive, shaped around you',
  'howwe.work.statement1': 'We do not fit your business into software.',
  'howwe.work.statement2': 'We shape technology around your business.',
  'howwe.work.fromRigid': 'From rigid to adaptive',
  'howwe.work.method': 'The MorphenIQ Method',

  // About — Hero
  'about.hero.badge': 'About MorphenIQ',
  'about.hero.title1': 'Intelligence built',
  'about.hero.title2': 'around people',
  'about.hero.title3': 'shaped for business.',
  'about.hero.subtitle':
    'MorphenIQ is an enterprise technology partner that designs custom AI, software, data and automation solutions around how your organization actually works — not the other way around.',
  'about.hero.support': 'We believe technology should adapt to businesses, not businesses to technology.',
  'about.hero.howWeWork': 'How We Work',

  // About — Who We Are
  'about.who.badge': 'Who We Are',
  'about.who.title': 'One core, many intelligent outcomes',
  'about.who.paragraph':
    'MorphenIQ sits between your existing systems and the results you need. We take what you already have — documents, databases, tools and processes — and shape it into intelligence your teams can actually use.',
  'about.who.p1.label': 'Custom AI',
  'about.who.p1.text': 'Models and assistants shaped around your workflows.',
  'about.who.p2.label': 'Software',
  'about.who.p2.text': 'Tools and applications built to fit how you work.',
  'about.who.p3.label': 'Data & Analytics',
  'about.who.p3.text': 'Turning scattered information into clear decisions.',
  'about.who.p4.label': 'Automation',
  'about.who.p4.text': 'Removing manual steps so your teams move faster.',

  // About — Mission
  'about.mission.badge': 'What We Believe',
  'about.mission.title': 'Principles that shape every build',
  'about.mission.paragraph':
    'Our mission is simple: turn organizational complexity into clear, useful intelligence that your teams can act on every day.',
  'about.mission.v1.title': 'Understand first',
  'about.mission.v1.text':
    'We start by learning how your teams work, what data you own, and where the friction is before proposing anything.',
  'about.mission.v2.title': 'Respect your data',
  'about.mission.v2.text':
    'Your private information stays yours. We design solutions that work within your security and compliance boundaries.',
  'about.mission.v3.title': 'Build on what exists',
  'about.mission.v3.text':
    'We integrate with the systems you already run instead of forcing you to replace them.',
  'about.mission.v4.title': 'Enable your people',
  'about.mission.v4.text':
    'Technology should make your teams more capable, not replace their judgment. We build tools people actually use.',

  // About — Team
  'about.team.badge': 'Our Team',
  'about.team.title': 'The people behind MorphenIQ',
  'about.team.paragraph':
    'A team with decades of experience across engineering, data, AI and operations leadership — guiding every project from strategy to execution.',
  'about.team.viewProfile': 'View profile',
  'about.team.close': 'Close',
  'about.team.comingSoon': 'Coming soon',
  'about.team.comingSoonText': 'We are preparing this profile.',
  'about.team.flipHint': 'Hover over a profile to see their full story',

  // About — Team: member profiles
  'about.team.m.jorge.role': 'Chief Executive Officer (CEO)',
  'about.team.m.jorge.bio':
    'Electronics Engineer with an MBA and a Master\'s in Big Data and Business Intelligence + Enterprise AI (ENEB). He brings more than three decades of experience in management, consulting and operations leadership, and served as General Manager of Symtek S.A.S. (2015–2023), where he now sits on the Board of Directors. He also has training in artificial intelligence (MIT xPRO) and astronomy. Since September 2026 he is CEO of MorphenIQ, leading the development of AI agents.',
  'about.team.m.jorge.tags': ['Strategic leadership', 'Business vision', 'Operations leadership', 'AI innovation'],
  'about.team.m.ivan.role': 'Sales Director & Deputy CEO',
  'about.team.m.ivan.bio':
    'Industrial Engineer, specialist in Production and Operations Management, with a Master\'s in Integral Logistics and an MBA, and currently a DBA candidate. He has 35 years of experience, including 25 as a management consultant, advising more than 100 companies on strategy, finance, operations and corporate governance. He is a director at ID Management Consulting and a professor at INALDE Business School. At MorphenIQ he brings executive experience, strategic judgment and senior relationship-building to create long-term commercial opportunities.',
  'about.team.m.ivan.tags': ['Commercial strategy', 'Executive relationships', 'Management consulting', 'Corporate governance'],
  'about.team.m.maria.role': 'Chief Marketing Officer (CMO)',
  'about.team.m.maria.bio':
    'Professional in Marketing and Digital Business and International Business Administration, with an MSc in Strategic and Digital Marketing from Rennes School of Business, France. She has international experience as a marketing consultant in strategy, social media, websites, events, brand positioning and analytics. At MorphenIQ she contributes to brand development, communication and commercial strategy, combining creativity, strategic thinking, analytical ability and a results-driven mindset to strengthen the company\'s positioning.',
  'about.team.m.maria.tags': ['Creativity', 'Strategic thinking', 'Analytical ability', 'Results-driven'],
  'about.team.m.claudia.role': 'AI Project Implementation Lead',
  'about.team.m.claudia.bio':
    'Systems Engineer (U. Piloto), with a Master\'s in Information Systems (U. Javeriana), a Master\'s in Software Engineering (DePaul University, USA) and a Specialization in AI (MIT). With 20 years of experience across the technology, healthcare, financial, education and government sectors, she was CTO of Topiary Communications, where she led SHARP for O\'Hare Airport, an FAA requirement. She has led AI projects such as SABIIA (DePaul University) and SpectraBot (Symtek S.A.S). Since September 2026 she leads AI Projects at MorphenIQ.',
  'about.team.m.claudia.tags': ['Project implementation', 'Software architecture', 'Technical leadership', 'Multi-sector experience'],
  'about.team.m.william.role': 'Design & Development Coordinator',
  'about.team.m.william.bio':
    'Systems Engineer with a specialization in Educational Project Management and more than 20 years of experience in software development, technical leadership and technology training. He has extensive experience in architecture, backend development, databases and systems integration. He stands out for leading teams and solving complex problems. Today, at MorphenIQ, he supports the technological development of solutions based on Artificial Intelligence, data analytics, automation and digital transformation, bringing innovation and strategic vision.',
  'about.team.m.william.tags': ['Software architecture', 'Backend development', 'Technical leadership', 'Digital transformation'],
  'about.team.m.evilio.role': 'Software Architect',
  'about.team.m.evilio.bio':
    'Systems Engineer with a specialization in Project Management, with a solid track record in software architecture and technical leadership. Notable is his design of the architecture for the 4-72 logistics system (SIPOST) in .NET, which supports the national operation, and his leadership in the architecture of XTAM, a video surveillance and analytics platform. At MorphenIQ he serves as Software Architect, bringing strategic vision for robust solutions that drive digital transformation.',
  'about.team.m.evilio.tags': ['Software architecture', 'Technical leadership', 'Project management', 'Digital transformation'],

  // About — Benefits
  'about.benefits.badge': 'Why Work With Us',
  'about.benefits.title': 'The benefits of building with MorphenIQ',
  'about.benefits.paragraph':
    'Working with a partner that shapes technology around your business changes everything — from how fast you see results to what it costs in the long run.',
  'about.benefits.b1.title': 'Faster time to value',
  'about.benefits.b1.text':
    'We ship working solutions in weeks, not quarters. You see results early and often, instead of waiting for a giant reveal.',
  'about.benefits.b2.title': 'Built around your workflows',
  'about.benefits.b2.text':
    'No generic templates. Every solution mirrors your exact processes, terminology and data structures from day one.',
  'about.benefits.b3.title': 'Enterprise-grade security',
  'about.benefits.b3.text':
    'Your data stays within your boundaries. We work with your compliance, governance and access-control requirements.',
  'about.benefits.b4.title': 'Lower total cost of ownership',
  'about.benefits.b4.text':
    'By connecting what you already have and building only what is missing, you avoid expensive rip-and-replace projects.',
  'about.benefits.b5.title': 'One integrated partner',
  'about.benefits.b5.text':
    'AI, software, data, integrations, analytics and automation under one roof — no juggling multiple disconnected vendors.',
  'about.benefits.b6.title': 'Measurable business impact',
  'about.benefits.b6.text':
    'Every build is tied to concrete outcomes: hours saved, errors reduced, decisions accelerated, revenue unlocked.',
  'about.benefits.cta': 'Start a Conversation',

  // About — Core diagram
  'about.core.cap.customAi.label': 'Custom AI',
  'about.core.cap.customAi.text': 'Assistants & models',
  'about.core.cap.software.label': 'Software',
  'about.core.cap.software.text': 'Apps & platforms',
  'about.core.cap.data.label': 'Data & Analytics',
  'about.core.cap.data.text': 'Insights & dashboards',
  'about.core.cap.automation.label': 'Automation',
  'about.core.cap.automation.text': 'Workflows & agents',
  'about.core.cap.integrations.label': 'Integrations',
  'about.core.cap.integrations.text': 'Connect your stack',
  'about.core.cap.security.label': 'Security',
  'about.core.cap.security.text': 'Enterprise-grade trust',

  // Shape Your Project
  'shape.badge': 'Start the Conversation',
  'shape.title': 'Shape Your Project',
  'shape.subtitle':
    'Tell us what you are trying to solve. You don\'t need to know exactly what technology you need — we\'ll help shape the right solution.',
  'shape.success.title': 'Thank You',
  'shape.success.text':
    'We have received your inquiry. Our team will review your project details and contact you within two business days.',
  'shape.name.label': 'Your name',
  'shape.name.placeholder': 'Your full name',
  'shape.contact.label': 'Contact number or WhatsApp',
  'shape.contact.placeholder': '+1 555 000 0000 (optional)',
  'shape.challenge.label': 'What challenge are you trying to solve?',
  'shape.challenge.placeholder':
    'Describe the business problem, process or opportunity you want to address...',
  'shape.challenge.max': 'Maximum 500 characters',
  'shape.category.label': 'Challenge category',
  'shape.category.placeholder': 'Select a category',
  'shape.systems.label': 'What systems, platforms or data sources are involved?',
  'shape.systems.placeholder': 'ERP, CRM, databases, documents, APIs, etc.',
  'shape.stage.label': 'Where are you in your project journey?',
  'shape.stage.placeholder': 'Select your stage',
  'shape.company.label': 'Company',
  'shape.company.placeholder': 'Organization name',
  'shape.role.label': 'Your role',
  'shape.role.placeholder': 'e.g. CTO, Operations Director',
  'shape.country.label': 'Country',
  'shape.country.placeholder': 'Country',
  'shape.email.label': 'Business email',
  'shape.email.placeholder': 'you@company.com',
  'shape.privacy':
    'We respect your privacy. Your information will only be used to respond to your inquiry.',
  'shape.submitting': 'Sending...',
  'shape.error.generic': 'Something went wrong. Please try again.',
  'shape.cat.knowledge': 'Knowledge management & search',
  'shape.cat.reporting': 'Reporting & analytics',
  'shape.cat.integration': 'System integration',
  'shape.cat.data': 'Data structuring & access',
  'shape.cat.automation': 'Process automation',
  'shape.cat.software': 'Custom software need',
  'shape.cat.ai': 'AI strategy & roadmap',
  'shape.cat.other': 'Other',
  'shape.stage.exploring': 'Exploring possibilities',
  'shape.stage.defined': 'Defined challenge, no solution',
  'shape.stage.concept': 'Have a concept, need validation',
  'shape.stage.ready': 'Ready to build',
  'shape.stage.existing': 'Have existing system, need evolution',

  // Book Meeting
  'meeting.badge': 'Book a Meeting',
  'meeting.title': 'Let\'s talk about your project',
  'meeting.subtitle': 'Pick a date and time that works for you. No strings attached.',
  'meeting.openCalendly': 'Open in Calendly',
  'meeting.duration': '45 minutes',
  'meeting.durationLabel': 'Duration',
  'meeting.typeLabel': 'Meeting type',
  'meeting.typeValue': 'Project discovery',
  'meeting.aboutLabel': 'About the meeting',
  'meeting.aboutText': 'We will talk about your challenge, your current systems, and how MorphenIQ can help you shape the right solution. No sales pitch. Just a useful conversation.',
  'meeting.prepLabel': 'Preparation',
  'meeting.prep1': 'Have a brief description of the challenge you are facing.',
  'meeting.prep2': 'Think about the systems or data involved.',
  'meeting.prep3': 'You do not need a ready technical proposal — we help with that.',
  'meeting.iframeTitle': 'MorphenIQ Meeting Calendar',
  'meeting.successTitle': 'Meeting booked!',
  'meeting.successText': 'Your meeting is confirmed. You will receive an email with the Google Meet link, date and time.',
  'meeting.backHome': 'Back to home',
  'meeting.timezoneLabel': 'Timezone',
  'meeting.timezoneValue': 'Americas (Bogotá, Jamaica, Lima, etc.)',
  'meeting.availabilityLabel': 'Availability',
  'meeting.availabilityValue': 'Mon – Fri, 8:00 AM – 5:00 PM',
  'meeting.afterLabel': 'After the meeting',
  'meeting.afterText': 'We will send you a follow-up summary with next steps, an estimated timeline, and a proposal tailored to your needs.',
  'meeting.languageLabel': 'Languages',
  'meeting.languageValue': 'English / Spanish',

  // Diagrams — Comparison
  'diagram.compare.generic.title': 'Generic AI',
  'diagram.compare.generic.subtitle': 'Knows the world',
  'diagram.compare.custom.title': 'MorphenIQ Custom AI',
  'diagram.compare.custom.subtitle': 'Knows your organization',
  'diagram.compare.generic.item1': 'General knowledge',
  'diagram.compare.generic.item2': 'Generic workflows',
  'diagram.compare.generic.item3': 'Broad language',
  'diagram.compare.generic.item4': 'Standard interfaces',
  'diagram.compare.generic.item5': 'Limited business context',
  'diagram.compare.custom.item1': 'Organizational knowledge',
  'diagram.compare.custom.item2': 'Your workflows',
  'diagram.compare.custom.item3': 'Your terminology',
  'diagram.compare.custom.item4': 'Role-based experience',
  'diagram.compare.custom.item5': 'Your business rules',
  'diagram.compare.custom.item6': 'Authorized private data',
  'diagram.compare.custom.item7': 'Context-specific design',

  // Diagrams — Process
  'diagram.process.step1.label': 'UNDERSTAND',
  'diagram.process.step1.desc': 'Business, processes, users, systems, data',
  'diagram.process.step2.label': 'SHAPE',
  'diagram.process.step2.desc': 'Use case, architecture, logic, UX, security',
  'diagram.process.step3.label': 'BUILD',
  'diagram.process.step3.desc': 'AI, software, integrations, dashboards',
  'diagram.process.step4.label': 'PROVE',
  'diagram.process.step4.desc': 'Adoption, accuracy, savings, ROI',
  'diagram.process.step5.label': 'EVOLVE',
  'diagram.process.step5.desc': 'New systems, users, data, use cases',

  // Diagrams — Intelligence Flow
  'diagram.flow.zone.systems': 'YOUR SYSTEMS',
  'diagram.flow.zone.outputs': 'INTELLIGENT OUTPUTS',
  'diagram.flow.zone.core': 'MORPHENIQ CORE',
  'diagram.flow.input.documents': 'Documents',
  'diagram.flow.input.erp': 'ERP',
  'diagram.flow.input.crm': 'CRM',
  'diagram.flow.input.databases': 'Databases',
  'diagram.flow.input.apis': 'APIs',
  'diagram.flow.input.bi': 'BI Tools',
  'diagram.flow.output.assistant': 'AI Assistant',
  'diagram.flow.output.dashboards': 'Dashboards',
  'diagram.flow.output.reports': 'Reports',
  'diagram.flow.output.automation': 'Automation',
  'diagram.flow.output.applications': 'Applications',
  'diagram.flow.output.decisions': 'Decisions',

  // Booking calendar
  'booking.stepDate': 'Choose date',
  'booking.stepTime': 'Choose time',
  'booking.stepReview': 'Your details',
  'booking.loading': 'Loading available times...',
  'booking.error': 'Something went wrong while loading availability.',
  'booking.retry': 'Try again',
  'booking.noSlots': 'No available times at the moment.',
  'booking.chooseDate': 'Select a date',
  'booking.chooseTime': 'Select a time',
  'booking.yourMeeting': 'Confirm your meeting',
  'booking.dateLabel': 'Date',
  'booking.startLabel': 'Starts',
  'booking.endLabel': 'Ends',
  'booking.modifyTime': 'Modify time',
  'booking.modifyDate': 'Change date',
  'booking.nameLabel': 'Your name',
  'booking.namePlaceholder': 'Full name',
  'booking.phoneLabel': 'Phone',
  'booking.phonePlaceholder': '+1 555 000 0000',
  'booking.emailLabel': 'Email address',
  'booking.emailPlaceholder': 'you@company.com',
  'booking.emailInvalid': 'Please enter a valid email.',
  'booking.optionalTitle': 'Tell us about your project (optional)',
  'booking.optionalHint': 'These answers help us prepare and arrive at the meeting with concrete ideas. Not required.',
  'booking.challengeLabel': 'What challenge are you trying to solve?',
  'booking.challengePlaceholder': 'Describe the business problem, process or opportunity you want to address...',
  'booking.categoryLabel': 'Challenge category',
  'booking.categoryPlaceholder': 'Select a category',
  'booking.systemsLabel': 'What systems, platforms or data sources are involved?',
  'booking.systemsPlaceholder': 'ERP, CRM, databases, documents, APIs, etc.',
  'booking.stageLabel': 'Where are you in your project journey?',
  'booking.stagePlaceholder': 'Select your stage',
  'booking.companyLabel': 'Company',
  'booking.companyPlaceholder': 'Organization name',
  'booking.roleLabel': 'Your role',
  'booking.rolePlaceholder': 'e.g. CTO, Operations Director',
  'booking.countryLabel': 'Country',
  'booking.countryPlaceholder': 'Country',
  'booking.notesLabel': 'Notes (optional)',
  'booking.notesPlaceholder': 'Anything you would like us to know before the call...',
  'booking.requiredError': 'Please fill in your name and phone number.',
  'booking.categories': [
    'Knowledge management & search',
    'Reporting & analytics',
    'System integration',
    'Data structuring & access',
    'Process automation',
    'Custom software need',
    'AI strategy & roadmap',
    'Other',
  ],
  'booking.stages': [
    'Exploring possibilities',
    'Defined challenge, no solution',
    'Have a concept, need validation',
    'Ready to build',
    'Have existing system, need evolution',
  ],
  'booking.submit': 'Confirm booking',
  'booking.submitting': 'Booking...',
  'booking.successTitle': "You're booked!",
  'booking.successText': "Your meeting is confirmed. We'll send you a confirmation and calendar invite shortly.",
  'booking.bookAnother': 'Book another meeting',
  'booking.months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  'booking.weekdays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  'booking.prevMonth': 'Previous month',
  'booking.nextMonth': 'Next month',
};